import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPenaltyStatus.ts
var t = () => e("penaltyStatus");
//#endregion
export { t as useTrPenaltyStatus };
